"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeaturedTemplatePreview = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var types_1 = require("CreatePageFlow/types");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("featured-template-preview");
var FeaturedTemplatePreview = function (props) {
    var pageCreationHelper = props.pageCreationHelper, onboarding = props.onboarding;
    var name = props.template.featuredTemplate.name;
    var urls = props.template.urls;
    var closeHandler = function () {
        props.onModalClose();
    };
    var routeToCreatePageFromTemplate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, pageCreationHelper.createPageFromTemplate({
                        projectId: props.template.featuredTemplate.projectId,
                        name: props.template.featuredTemplate.name,
                        isAccountTemplate: false,
                    }, { isOnboarding: !!onboarding })];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("nav") },
            react_1.default.createElement("div", { className: c("nav-left") },
                react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "s", long: true }, "Template Preview"),
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true, className: "nav-left__title" }, name)),
            react_1.default.createElement("div", { className: c("nav-right") },
                react_1.default.createElement(kaleidoscope_3.Button, { className: c("action-button"), onClick: function () { return routeToCreatePageFromTemplate(); } }, "Create page"),
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), onClick: closeHandler }))),
        react_1.default.createElement("div", { className: c("body") },
            react_1.default.createElement("iframe", { className: c("body-frame"), src: (0, CommonUtils_1.addParamsToUrl)(urls.collaboratorUrl, { hideCollaboratorNav: "true" }) }),
            react_1.default.createElement("div", { className: c("sidebar") },
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("sidebar-panel"), c("sidebar-panel--createdby")) },
                    react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "s", long: true }, "Created by"),
                    react_1.default.createElement("div", { className: c("user") },
                        react_1.default.createElement("div", { className: c("user-avatar") },
                            react_1.default.createElement("img", { src: "".concat(types_1.ASSETS_DIR, "Images/LogoColor.svg") })),
                        react_1.default.createElement("div", { className: c("user-details") },
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "m", strong: true }, "Qwilr")))),
                react_1.default.createElement("div", { className: c("sidebar-panel") },
                    react_1.default.createElement("div", { className: c("about") },
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "left" }, props.template.metadata.about)),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s", align: "left", strong: true, className: c("included-title") }, "What's included?"),
                    react_1.default.createElement(kaleidoscope_2.Stack, { direction: "vertical", gap: "xs" }, props.template.metadata.inclusions.map(function (inclusion) { return (react_1.default.createElement("div", { className: c("inclusion") },
                        react_1.default.createElement("img", { src: "/Assets/icons/tick-bubble.svg" }),
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "left" }, inclusion))); })))))));
};
exports.FeaturedTemplatePreview = FeaturedTemplatePreview;
